<template>
  <div>
    <app-nav :full-name="userFullName"/>
    <div class="columns">
      <div class="column"/>
      <div class="column is-four-fifths">
        <div class="columns">
          <div class="column is-three-fourths">

            <b-field>
              <b-autocomplete
                :keep-first="true"
                :open-on-focus="false"
                :data="overviews"
                field="articleId"
                icon-pack="fas"
                icon="search"
                placeholder="Search article ..."
                @select="selectArticle" />
            </b-field>
          </div>

          <div class="column is-one-quarter">

            <router-link
              to="/fabric"
              class="button is-link is-outlined">
              <span class="icon is-small">
                <i class="fas fa-plus" />
              </span>
              <span>Create new article</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="column" />
    </div>

    <div class="columns">
      <div class="column"/>
      <div class="column is-four-fifths">
        <b-table
          ref="mainTable"
          :data="overviews"
          default-sort="lastUpdated"
          default-sort-direction="desc"
          paginated
          pagination-size="is-small"
          per-page="10">

          <template slot-scope="props">
            <b-table-column
              field="articleId"
              label="Article"
              sortable>
              <router-link :to="'/fabrics/' + props.row.articleId">{{ props.row.articleId }}</router-link>
            </b-table-column>

            <b-table-column
              field="createdBy"
              label="Created by"
              sortable>
              {{ props.row.createdBy }}
            </b-table-column>

            <b-table-column
              field="createdOn"
              label="Created on"
              sortable>
              {{ format(props.row.createdOn) }}
            </b-table-column>

            <b-table-column
              field="lastUpdatedby"
              label="Last updated by"
              sortable>
              {{ props.row.lastUpdatedBy }}
            </b-table-column>

            <b-table-column
              field="lastUpdated"
              label="Last updated on"
              sortable>
              {{ format(props.row.lastUpdated) }}
            </b-table-column>

          </template>
        </b-table>
      </div>
      <div class="column"/>
    </div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true" />
  </div>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { format } from '../utils/datetime'
import { getFabricsOverview } from '../utils/rfi'

export default {
  name: 'overview',
  components: {
    AppNav
  },
  data() {
    return {
      overviews: [],
      userFullName: '',
      // loading
      isLoading: false,
      // table elements
      columns: [
        {
          field: 'articleId',
          label: 'Article',
          sortable: true
        },
        {
          field: 'createdBy',
          label: 'Created by',
          sortable: true
        },
        {
          field: 'createdOn',
          label: 'Created on',
          sortable: true
        },
        {
          field: 'lastUpdatedBy',
          label: 'Last updated by',
          sortable: true
        },
        {
          field: 'lastUpdated',
          label: 'Last updated',
          sortable: true
        }
      ],
      options: {

      }
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.isLoading = true
        self.getFabricsOverview()
        self.userFullName = JSON.parse(getUser()).fullName
        self.isLoading = false
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    getFabricsOverview() {
      getFabricsOverview().then((overviews) => {
        this.overviews = overviews
      })
    },
    format(timestamp) {
      return format(timestamp)
    },
    sortDatetime(x, y, col) {
      return (x < y ? -1 : (x > y ? 1 : 0))
    },
    selectArticle(article) {
      this.$router.push('/fabrics/' + article.articleId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smaller {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Overview.vue